import AdminResellers from '@/pages/admin-resellers/AdminResellers';

export default AdminResellers;
